export default __webpack_public_path__ + "static/media/Class-10-State-English.7a94dac3.pdf";